module.exports = __webpack_public_path__ + "img/bg.39e56b0f.jpg";